<template>
  <div class="skeleton-placeholder" :aria-label="ariaLabel">
    <div class="skeleton-entry">
      <div class="skeleton-icon"></div>
      <div class="skeleton-content">
        <div class="skeleton-line skeleton-title"></div>
        <div class="skeleton-line skeleton-subtitle"></div>
        <div class="skeleton-line skeleton-meta"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SkeletonPlaceholder',
  props: {
    ariaLabel: {
      type: String,
      default: 'Loading placeholder'
    }
  }
}
</script>

<style scoped>
.skeleton-placeholder {
  padding: 16px 0;
}

.skeleton-entry {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 20px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  animation: skeleton-pulse 1.5s ease-in-out infinite alternate;
}

.skeleton-icon {
  width: 48px;
  height: 48px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.1);
  flex-shrink: 0;
}

.skeleton-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.skeleton-line {
  height: 16px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  animation: skeleton-shimmer 1.5s ease-in-out infinite alternate;
}

.skeleton-title {
  width: 70%;
  height: 20px;
}

.skeleton-subtitle {
  width: 85%;
}

.skeleton-meta {
  width: 40%;
  height: 14px;
}

@keyframes skeleton-pulse {
  0% {
    opacity: 0.6;
  }
  100% {
    opacity: 0.8;
  }
}

@keyframes skeleton-shimmer {
  0% {
    background: rgba(255, 255, 255, 0.1);
  }
  100% {
    background: rgba(255, 255, 255, 0.2);
  }
}

/* Reduced motion support */
@media (prefers-reduced-motion: reduce) {
  .skeleton-entry,
  .skeleton-line {
    animation: none;
  }
}
</style>